export default "__VITE_ASSET__BZjyiJ2___"